import {
  CLEAR_ENABLE_USER_ERROR,
  CLEAR_LOGIN_ERROR,
  ENABLE_USER_ERROR,
  ENABLE_USER_PENDING,
  ENABLE_USER_PENDING_ERROR,
  ENABLE_USER_PENDING_SUCCESS,
  LOGIN_ERROR,
  LOGIN_PENDING,
  LOGIN_PENDING_ERROR,
  LOGIN_PENDING_SUCCESS,
  LOGIN_SUCCESS,
  USER_LOGOUT,
  ACTIVATE_ACCOUNT_ERROR,
  ACTIVATE_ACCOUNT_SUCCESS,
  SET_ACTIVATION_PENDING,
  CLEAR_ACTIVATION_PENDING,
  SET_ACTIVATION_ERROR_MESSAGE,
  SET_AUTH,
  SET_ACTIVATION_SUCCESS_MESSAGE
} from "../constants/login.constants";

export const loginUserPending = (): Action => ({
  type: LOGIN_PENDING,
});

export const loginUserPendingError = (): Action => ({
  type: LOGIN_PENDING_ERROR,
});

export const loginUserPendingSuccess = (): Action => ({
  type: LOGIN_PENDING_SUCCESS,
});

export const setLoginSuccessMessage = (loginSuccesMessage: string): Action => ({
  type: SET_ACTIVATION_SUCCESS_MESSAGE,
  payload: loginSuccesMessage,
})

export const loginUserSuccess = (
  email: string,
  token: string,
  expires: number
): Action => ({
  type: LOGIN_SUCCESS,
  payload: { email, token, expires },
});

export const logoutUser = () => (dispatch: Function) => {
  dispatch(setAuth(false));
  dispatch({ type: USER_LOGOUT });

  // const currentState = getState();
  // const { email } = currentState && currentState.login;
  // getToken(dispatch).then((accessToken) => {
  //   agent.Auth.logout(accessToken, email, actionType)
  //     .then(() => {
  //       dispatch({ type: USER_LOGOUT });
  //     })
  //     .catch((err) => {
  //       dispatch(
  //         showSnackbarStatus("Something went wrong. Please try again later")
  //       );
  //     });
  // });
};

export const loginUserError = (errorMessage: string): Action => ({
  type: LOGIN_ERROR,
  payload: { errorMessage },
});

export const clearLoginUserError = (): Action => ({
  type: CLEAR_LOGIN_ERROR,
});

export const enableUserError = (errorMessage: string): Action => ({
  type: ENABLE_USER_ERROR,
  payload: { errorMessage },
});

export const enableUserPending = (): Action => ({
  type: ENABLE_USER_PENDING,
});

export const enableUserPendingSuccess = (): Action => ({
  type: ENABLE_USER_PENDING_SUCCESS,
});

export const clearEnableUserError = (): Action => ({
  type: CLEAR_ENABLE_USER_ERROR,
});

export const enableUserPendingError = (): Action => ({
  type: ENABLE_USER_PENDING_ERROR,
});

export const activateUserError = (): Action => ({
  type: ACTIVATE_ACCOUNT_ERROR,
});

export const activationSuccess = (): Action => ({
  type: ACTIVATE_ACCOUNT_SUCCESS,
});

export const setActivationPending = ():Action =>({
  type: SET_ACTIVATION_PENDING
});

export const clearActivationPending = ():Action =>({
  type: CLEAR_ACTIVATION_PENDING
});

export const setActivationErrorMessage = (activationError: string):Action=>({
  type: SET_ACTIVATION_ERROR_MESSAGE,
  payload: {activationError}
});


export const setAuth = (value): Action => ({
  type: SET_AUTH,
  payload: value
});
